/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CardDispatchDto {
    SHIPPING_TO_COMPANY = 'SHIPPING_TO_COMPANY',
    SHIPPING_TO_MARKET = 'SHIPPING_TO_MARKET',
}
